export class EmailsList {

  public id: number;
  public title: string;
  public enabled: boolean;
  public contentType: string;
  public recipients: string;
  public description: string;

}
